import { User } from "model/user.model";
import { TenantData } from "model/tenant-data.model";

/** ---- Dispatch Types ---- */
export const UPDATE_USERS_LIST = "UPDATE_USERS_LIST";
export const UPDATE_TENANT_DATA = "UPDATE_TENANT_DATA";

/** ---- Dispatch Interfaces ---- */
export type UsersMap = { [k: number]: User };

export interface TenantContext {
  users: UsersMap;
  tenantData: TenantData;
}

interface UpdateUsersList {
  type: typeof UPDATE_USERS_LIST;
  payload: UsersMap;
}

interface UpdateTenantData {
  type: typeof UPDATE_TENANT_DATA;
  payload: TenantData;
}

export type TenantContextAction = UpdateUsersList | UpdateTenantData;
